<div *ngIf="wrapped" class="form-group" [ngClass]="wrappedClass">
    <label for="{{name}}">{{label || (name | stringSpacer)}}:</label>
    <input #input type="text" [name]="name" [id]="name" [attr.disabled]="disabled ? 'disabled' : null" [ngClass]="class"
        placeholder="{{placeholder}}" class="form-control form-control-sm text-right" [(ngModel)]="display"
        (ngModelChange)="modelChanged($event)" (blur)="onBlur()" (focus)="onFocus()" autocomplete="off"/>
</div>
<input *ngIf="!wrapped" #input [name]="name" [id]="name" type="text" [attr.disabled]="disabled ? 'disabled' : null" [ngClass]="class"
    placeholder="{{placeholder}}" class="form-control form-control-sm text-right" [(ngModel)]="display"
    (ngModelChange)="modelChanged($event)" (blur)="onBlur()" (focus)="onFocus()" autocomplete="off"/>
